import React from 'react';
import { useSelector } from 'react-redux';

import { Grid } from '@material-ui/core';

import { useCurrentUser } from '@klp/auth';
import { contextSelectors } from '@klp/contextSelector/store/contextSelectorSlice';

import { useFrontpageCardSelection } from '../hooks/useFrontpageCardSelection';
import { createFrontpageCardsConfig } from './frontpageCardsConfig';
import { FrontpageCardWrapper } from './FrontpageCardWrapper';

export default function FrontpageCards() {
    const { currentUser } = useCurrentUser();
    const { selectedContext } = useSelector(contextSelectors);
    const { cardsToRender } = useFrontpageCardSelection();

    const frontpageCardsConfig = createFrontpageCardsConfig({
        currentUser,
        selectedContext,
    });

    // Filter out cards that are not visible (e.g., due to access restrictions)
    const visibleCards = cardsToRender.filter((cardType) =>
        frontpageCardsConfig[cardType].isVisible(),
    );

    return (
        <Grid container={true} spacing={2}>
            {visibleCards.map((cardType) => (
                <FrontpageCardWrapper
                    key={cardType}
                    cardType={cardType}
                    config={frontpageCardsConfig[cardType]}
                />
            ))}
        </Grid>
    );
}
